/**
 * Returns the window opener if it exists, otherwise returns the parent window.
 * @returns {Window} The window opener or parent window.
 */
export const opener = () => (window.opener ? window.opener : window.parent)

/**
 * Sends an image to a specified domain using the postMessage method.
 * @param {string} image - The base64 image to send.
 * @param {string} domain - The domain to send the image to.
 */
export const sendImage = (image, domain) => {
  if (!domain || !domain.length) return
  opener().postMessage(
    {
      event: 'image',
      data: image
    },
    domain
  )
}

/**
 * Sends a 'ready' state message to a specified domain using the postMessage method.
 * @param {string} domain - The domain to send the message to.
 */
export const pixelReady = domain => {
  if (!domain || !domain.length) return
  opener().postMessage(
    {
      event: 'state',
      data: 'ready'
    },
    domain
  )
}

/**
 * Sends an 'upgrade' event with a specified action to a specified domain using the postMessage method.
 * @param {string} action - The action to send.
 * @param {string} domain - The domain to send the message to.
 */
export const openModal = (action, domain) => {
  if (!domain || !domain.length) return

  opener().postMessage(
    {
      event: 'upgrade',
      data: action
    },
    domain
  )
}

/**
 * Sends a 'closePixel' event with a 'close' data to a specified domain using the postMessage method.
 * @param {string} domain - The domain to send the message to.
 */
export const closePixel = domain => {
  if (!domain || !domain.length) return

  opener().postMessage(
    {
      event: 'closePixel',
      data: 'close'
    },
    domain
  )
}

/**
 * Sends a 'clickLogo' event with a 'click_logo' data to a specified domain using the postMessage method.
 * @param {string} domain - The domain to send the message to.
 */
export const clickLogo = domain => {
  if (!domain || !domain.length) return

  opener().postMessage(
    {
      event: 'clickLogo',
      data: 'click_logo'
    },
    domain
  )
}

/**
 * Sends an 'onSave' event with specified data to a specified domain using the postMessage method.
 * @param {string} domain - The domain to send the message to.
 * @param {any} data - The data to send.
 */
export const clickMenu = (domain, data) => {
  if (!domain || !domain.length) return

  opener().postMessage(
    {
      event: 'onSave',
      data
    },
    domain
  )
}



// WEBPACK FOOTER //
// ./src/model/PixelIOGateway.js